import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export const licencaBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Revenda",
    url: "#!",
  },
  {
    label: "Licença",
    active: true,
  },
];
